export enum CreateSnapShotFromPageE {
    // 前三个是LUN的多入口，影响联机帮助
    Lun = 'lun',
    ProtectLun = 'protect_lun',
    LunSnapshot = 'snapshot',

    // FS场景
    Fs = 'fs',
}
